export default __webpack_public_path__ + "static/billboard-divider2025-95aee801564fe5ba169c9125fd55d4ba.png";